// extracted by mini-css-extract-plugin
export default {"container":"Subscription_container__LywXY","subContainer":"Subscription_subContainer__Q4D2P","leftArrow":"Subscription_leftArrow__m-y6J"};